import { render, staticRenderFns } from "./WechatBind.vue?vue&type=template&id=c2d28f40&"
import script from "./WechatBind.vue?vue&type=script&lang=ts&"
export * from "./WechatBind.vue?vue&type=script&lang=ts&"
import style0 from "./WechatBind.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports